import React from 'react';
import { Button } from "devextreme-react/button";
import './Help.css';

export default function Help() {
    return (
        <React.Fragment>
            <h2 className={'content-block'}>Помощь</h2>

            {/* Блок поддержки */}
            <div className="support-wrapper">
                <a href={'https://max.ru/join/aZteTrl0dQ3kLEyugAIW3MLsNguvAimiZs1cLttswWc'} target={'_blank'} rel="noreferrer">
                    <center>
                        <Button
                            text="Задать вопрос"
                            type="success"
                            stylingMode="outlined"
                            icon="help"
                        />
                    </center>
                </a>
                <div className="support-note">
                    При обращении в техническую поддержку обязательно указывайте код пищеблока в базе ФЦМПО
                </div>
            </div>

            {/* Сетка с материалами - 2 колонки для лучшей обозримости */}
            <div className="materials-grid">
                {/* ШАБЛОНЫ */}
                <div className={'content-block'}>
                    <div className={'dx-card responsive-paddings'} style={{ fontSize: '1em', height: '100%' }}>
                        <div className={'title-table'}><b>📄 ШАБЛОНЫ</b></div>
                        <ul className="material-list">
                            <li><a href={require('./file/ГГГГ-ММ-ДД-sm.xlsx')} download="ГГГГ-ММ-ДД-sm" target="_blank" rel="noreferrer">Ежедневное меню</a></li>
                            <li><a href={require('./file/rashir/ГГГГ-ММ-ДД-sm.xlsx')} download="ГГГГ-ММ-ДД-sm" target="_blank" rel="noreferrer">Ежедневное меню (расширенный вариант)</a></li>
                            <li><a href={require('./file/findex.xlsx')} download="findex" target="_blank" rel="noreferrer">Рейтинг общественной оценки</a></li>
                            <li className="separator"><span>Типовые меню:</span></li>
                            <li><a href={require('./file/tm2025-sm.xlsx')} download="tm2026-sm" target="_blank" rel="noreferrer">2×5 (10 дней)</a></li>
                            <li><a href={require('./file/tm2025-2x6.xlsx')} download="tm2026-sm" target="_blank" rel="noreferrer">2×6 (12 дней)</a></li>
                            <li><a href={require('./file/tm2025-sm-2х7.xlsx')} download="tm2026-sm" target="_blank" rel="noreferrer">2×7 (14 дней)</a></li>
                            <li><a href={require('./file/tm2025-sm-3x5.xlsx')} download="tm2026-sm" target="_blank" rel="noreferrer">3×5 (15 дней)</a></li>
                            <li><a href={require('./file/tm2025-4x5.xlsx')} download="tm2026-sm" target="_blank" rel="noreferrer">4×5 (20 дней)</a></li>
                            <li><a href={require('./file/kp2026.xlsx')} download="kp2026" target="_blank" rel="noreferrer">Календарь питания</a></li>
                        </ul>
                    </div>
                </div>

                {/* ИНСТРУКЦИИ */}
                <div className={'content-block'}>
                    <div className={'dx-card responsive-paddings'} style={{ fontSize: '1em', height: '100%' }}>
                        <div className={'title-table'}><b>📖 ИНСТРУКЦИИ</b></div>
                        <ul className="material-list">
                            <li><a href={require('./file/Инструкция.pdf')} download="Инструкция" target="_blank" rel="noreferrer">Общая инструкция по мониторингу</a></li>
                            <li><a href={require('./file/tp_instr.pdf')} download="Инструкция_ТП_КП" target="_blank" rel="noreferrer">Инструкция по Типовому меню и Календарю питания</a></li>
                        </ul>
                    </div>
                </div>

                {/* НОРМАТИВНАЯ БАЗА */}
                <div className={'content-block'}>
                    <div className={'dx-card responsive-paddings'} style={{ fontSize: '1em', height: '100%' }}>
                        <div className={'title-table'}><b>⚖️ НОРМАТИВНАЯ БАЗА</b></div>
                        <ul className="material-list">
                            <li><a href={require('./file/1158.pdf')} download="1158" target="_blank" rel="noreferrer">Письмо Минпросвещения № ГД-1158/01 от 17.05.2021</a></li>
                            <li><a href={require('./file/1153.pdf')} download="1158" target="_blank" rel="noreferrer">Письмо Минпросвещения № АК-1153/10 от 23.08.2022</a></li>
                        </ul>
                    </div>
                </div>

                {/* ВИДЕО */}
                <div className={'content-block'}>
                    <div className={'dx-card responsive-paddings'} style={{ fontSize: '1em', height: '100%' }}>
                        <div className={'title-table'}><b>🎥 ВИДЕОМАТЕРИАЛЫ</b></div>
                        <ul className="material-list">
                            <li className="video-link">
                                Запись вебинаров на тему «Школьное питание»
                                <a href={'https://rutube.ru/channel/35063550'} target="_blank" rel="noreferrer"> rutube.ru/channel/35063550</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}